var _defs, _defs2, _defs3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.52
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    x1: 123.262,
    y1: 114.528,
    x2: 240.455,
    y2: 205.455
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    x1: 261.715,
    y1: 77.514,
    x2: 239.975,
    y2: 204.684
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    x1: 370.027,
    y1: 117.433,
    x2: 239.129,
    y2: 204.356
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    x1: 359.233,
    y1: 258.726,
    x2: 240.013,
    y2: 205.089
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    x1: 128.636,
    y1: 271.062,
    x2: 239.938,
    y2: 204.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0765 -0.9971 0.9971 0.0765 -13.7197 211.6905)",
    style: {
      fill: "#84C1C4"
    },
    cx: 107.422,
    cy: 113.252,
    rx: 31.658,
    ry: 31.658
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -47.4722 102.4338)",
    style: {
      opacity: 0.52,
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    cx: 99.912,
    cy: 108.521,
    rx: 31.658,
    ry: 31.658
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9737 -0.2277 0.2277 0.9737 -20.6187 27.0668)",
    style: {
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 106.978,
    cy: 102.879,
    rx: 20.618,
    ry: 20.618
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.47,
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M125.913,94.724 c0.284,5.646-1.562,11.314-5.917,15.934c-7.644,8.109-19.577,9.616-28.518,2.848c-1.391-1.053-2.67-2.253-3.846-3.552 c2.889,7.897,10.448,13.544,19.345,13.544c11.387,0,20.618-9.231,20.618-20.618C127.596,99.981,126.992,97.226,125.913,94.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M90.232,92.169c1.19-0.406,2.402-0.737,3.643-0.943c0.819-0.135,1.645-0.224,2.474-0.264 c0.625-0.03,0.744-0.005,1.352,0.303c0.74,0.375,0.706,0.432,0.7,1.157c-0.013,1.57,0.086,2.601,1.46,3.549 c0.61,0.42,1.294,0.722,1.899,1.149c1.318,0.93,1.408,2.274,0.548,3.613c-0.63,0.981-1.964,2.664-3.274,2.269 c-0.919-0.277-1.588-1.096-2.525-1.355c-1.469-0.406-2.808,0.602-3.337,1.941c-0.744,1.882,0.312,4.212,1.443,5.721 c0.925,1.235,1.967,0.662,2.943-0.145c0.564-0.466,1.177-1.033,1.94-0.6c0.75,0.426,0.957,1.321,0.436,2.017 c-0.507,0.678-1.339,0.904-1.498,1.826c-0.095,0.553,0.068,1.147,0.621,1.382c0.433,0.184,0.932-0.025,1.383,0.1 c0.68,0.189,1.167,0.835,1.522,1.4c1.55,2.466,2.576,5.402,3.801,8.043c0.203,0.438,0.85,0.057,0.648-0.379 c-1.17-2.522-2.22-5.156-3.544-7.6c-0.386-0.713-0.882-1.465-1.589-1.899c-0.287-0.176-0.602-0.3-0.937-0.348 c-0.181-0.026-0.424,0.044-0.587-0.006c-0.91-0.279-0.509-0.883-0.013-1.367c0.53-0.517,1.158-0.884,1.263-1.679 c0.09-0.683-0.24-1.37-0.73-1.831c-1.303-1.223-2.452-0.187-3.562,0.67c-1.465,1.131-2.676-1.952-2.919-3.005 c-0.417-1.81,0.812-4.412,3.009-3.311c1.521,0.762,2.645,1.915,4.27,0.633c1.318-1.04,2.974-2.99,2.558-4.809 c-0.357-1.56-1.964-2.153-3.166-2.931c-1.243-0.804-1.333-1.642-1.316-3.05c0.009-0.731-0.061-1.51-0.73-1.95 c-0.98-0.645-2.701-0.247-3.764-0.113c-1.581,0.199-3.118,0.572-4.625,1.086C89.578,91.6,89.774,92.325,90.232,92.169 L90.232,92.169z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M109.095,82.209c-0.689,1.137-0.896,2.48-0.484,3.758c0.414,1.283,1.402,2.079,2.424,2.883 c0.532,0.418,1.079,0.835,1.48,1.385c0.81,1.11,0.494,2.367-0.064,3.508c-0.899,1.839-2.065,3.582-3.098,5.348 c-0.765,1.309-1.932,2.832-1.77,4.443c0.1,0.995,0.781,2.005,1.822,2.161c1.375,0.207,2.383-1.13,3.351-1.868 c0.474-0.361,2.141-1.714,2.751-0.947c0.135,0.169,0.114,0.597,0.224,0.822c0.097,0.197,0.225,0.385,0.373,0.548 c0.902,0.987,2.402,1.188,3.657,1.326c2.294,0.251,4.59,0.485,6.885,0.727c0.479,0.051,0.476-0.7,0-0.75 c-2.221-0.235-4.444-0.455-6.663-0.704c-0.931-0.104-1.967-0.195-2.791-0.693c-0.811-0.49-0.721-1.085-1.051-1.828 c-0.595-1.342-2.382-0.084-3.174,0.43c-0.844,0.547-1.509,1.338-2.354,1.868c-1.916,1.204-2.536-1.124-2.052-2.493 c0.384-1.085,1.096-2.079,1.675-3.068c0.591-1.01,1.182-2.02,1.772-3.03c0.85-1.452,2.061-3.125,1.714-4.908 c-0.276-1.419-1.464-2.245-2.523-3.093c-1.736-1.39-2.742-3.33-1.458-5.448C109.993,82.174,109.345,81.796,109.095,82.209 L109.095,82.209z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M113.932,121.868c-1.453-2.643,0.303-5.935,2.951-6.942c1.466-0.557,3.1-0.56,4.605-0.155 c0.377,0.102,0.741,0.233,1.103,0.378c0.266,0.106,0.574,0.178,0.809-0.045c0.384-0.367-0.145-1.094-0.585-0.754 c-0.377,0.291-0.004,0.942,0.379,0.648c0.015-0.011,0.029-0.023,0.044-0.034c-0.096,0.013-0.193,0.025-0.289,0.038 c-0.049-0.041-0.099-0.082-0.148-0.123c0.013-0.096,0.025-0.193,0.038-0.289c-0.009,0.02-0.018,0.04-0.028,0.06 c0.075-0.057,0.149-0.115,0.224-0.172c-0.126,0.053-0.452-0.136-0.568-0.179c-0.186-0.069-0.374-0.132-0.565-0.189 c-0.334-0.099-0.674-0.179-1.017-0.237c-0.717-0.123-1.448-0.169-2.174-0.109c-1.423,0.117-2.816,0.605-3.917,1.529 c-1.965,1.649-2.775,4.654-1.51,6.955C113.517,122.67,114.165,122.292,113.932,121.868L113.932,121.868z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B938"
    },
    d: "M118.349,69.857c-4.04,0-7.316,3.275-7.316,7.316c0,4.04,7.316,16.883,7.316,16.883 s7.316-12.842,7.316-16.883C125.665,73.133,122.389,69.857,118.349,69.857z M118.349,79.987c-1.554,0-2.814-1.26-2.814-2.814 c0-1.554,1.26-2.814,2.814-2.814c1.554,0,2.814,1.26,2.814,2.814C121.163,78.727,119.903,79.987,118.349,79.987z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 87.7551 136.6211)",
    style: {
      fill: "#2A3E5E",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 12
    }
  }, "Travel")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5895 -0.8078 0.8078 0.5895 -163.5751 212.954)",
    style: {
      fill: "#84C1C4"
    },
    cx: 127.726,
    cy: 267.409,
    rx: 31.658,
    ry: 31.658
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2085 -0.978 0.978 0.2085 -161.9339 320.4401)",
    style: {
      opacity: 0.52,
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    cx: 117,
    cy: 260.262,
    rx: 31.658,
    ry: 31.658
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.139,
    y: 237.144,
    style: {
      fill: "none",
      stroke: "#9CA0A2",
      strokeWidth: 0.7641,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    width: 52.294,
    height: 29.878
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M135.131,261l-8.038-13.684c-0.055-0.075-0.173-0.036-0.173,0.056v11.669 c0,0.034,0.021,0.064,0.051,0.081c0.311,0.166,0.464,0.59,0.173,0.987c-0.007,0.009-0.015,0.018-0.024,0.024 c-0.507,0.372-1.059,0.019-1.059-0.464c0-0.236,0.132-0.44,0.325-0.545c0.032-0.017,0.054-0.049,0.054-0.086v-11.665 c0-0.093-0.119-0.131-0.173-0.056l-8.066,13.403c-0.023,0.032-0.024,0.075-0.003,0.108l3.986,8.441h8.992l3.958-8.16 C135.156,261.075,135.154,261.032,135.131,261z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M130.733,273.543h-8.105c-0.286,0-0.517-0.232-0.517-0.517v-3.31 c0-0.056,0.046-0.102,0.102-0.102h8.935c0.057,0,0.102,0.046,0.102,0.102v3.31C131.25,273.311,131.018,273.543,130.733,273.543 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.634,
    y: 264.89,
    style: {
      fill: "#FFC94A"
    },
    width: 3.606,
    height: 3.606
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.634,
    y: 235.293,
    style: {
      fill: "#FFC94A"
    },
    width: 3.606,
    height: 3.606
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.092,
    y: 264.89,
    style: {
      fill: "#FFC94A"
    },
    width: 3.606,
    height: 3.606
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.092,
    y: 235.293,
    style: {
      fill: "#FFC94A"
    },
    width: 3.606,
    height: 3.606
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC94A"
    },
    cx: 126.644,
    cy: 235.906,
    r: 7.981
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#28787C"
    },
    cx: 135.29,
    cy: 240.562,
    r: 7.981
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 99.7265 289.1466)",
    style: {
      fill: "#2A3E5E",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 12
    }
  }, "Designer")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.266 -0.964 0.964 0.266 128.7806 300.2738)",
    style: {
      fill: "#84C1C4"
    },
    cx: 261.576,
    cy: 65.569,
    rx: 31.658,
    ry: 31.658
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 37.7919 203.8109)",
    style: {
      opacity: 0.52,
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    cx: 264.917,
    cy: 56.287,
    rx: 31.658,
    ry: 31.658
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M280.896,66.105h-25.54v-37.74h25.54c1.322,0,2.393,1.071,2.393,2.393v32.954 C283.289,65.033,282.218,66.105,280.896,66.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M264.305,59.925c-5.354-7.737-8.013-17.935-8.949-27.659v33.839h15 C267.981,64.509,265.964,62.321,264.305,59.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M283.289,60.358V55.52c-9.316-0.2-18.627-0.529-27.933-1.004v5.452 C264.669,59.893,273.98,60.082,283.289,60.358z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.2234,
      strokeMiterlimit: 10
    },
    points: "266.054,47.086  262.785,44.412 259.813,47.086 259.813,28.365 266.054,28.365  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28787C"
    },
    d: "M268.925,69.862h-25.54v-37.74h25.54c1.322,0,2.393,1.071,2.393,2.393v32.954 C271.318,68.79,270.246,69.862,268.925,69.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M252.334,63.682c-5.354-7.737-8.013-17.935-8.949-27.659v33.839h15 C256.009,68.267,253.992,66.079,252.334,63.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M271.318,64.116v-4.838c-9.315-0.2-18.627-0.529-27.933-1.004v5.452 C252.698,63.65,262.008,63.839,271.318,64.116z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.2234,
      strokeMiterlimit: 10
    },
    points: "254.082,50.843  250.813,48.169 247.842,50.843 247.842,32.122 254.082,32.122  "
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 244.0493 84.3013)",
    style: {
      fill: "#2A3E5E",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 12
    }
  }, "Books")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2517 -0.9678 0.9678 0.2517 179.2375 450.463)",
    style: {
      fill: "#84C1C4"
    },
    cx: 380.926,
    cy: 109.321,
    rx: 31.658,
    ry: 31.658
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2667 -0.9638 0.9638 0.2667 182.02 454.112)",
    style: {
      opacity: 0.52,
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    cx: 389.446,
    cy: 107.435,
    rx: 31.658,
    ry: 31.658
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B938"
    },
    d: "M397.445,114.2h-33.756c-8.571,0-15.518-6.948-15.518-15.519l0,0 c0-8.571,6.948-15.519,15.518-15.519h33.756c8.571,0,15.518,6.948,15.518,15.519l0,0 C412.964,107.252,406.016,114.2,397.445,114.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.792,
    y: 85.93,
    style: {
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.2314,
      strokeMiterlimit: 10
    },
    width: 31.48,
    height: 25.051
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.2314,
      strokeMiterlimit: 10
    },
    d: "M376.262,102.653 c-4.987-4.898-8.022-10.704-10.47-16.615v24.944h24.818C385.108,109.243,380.215,106.535,376.262,102.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.2345,
      strokeMiterlimit: 10
    },
    d: "M401.152,110.705h-1.663 c-0.551,0-0.998-0.447-0.998-0.998l0,0c0-0.551,0.447-0.998,0.998-0.998h1.663c0.551,0,0.998,0.447,0.998,0.998l0,0 C402.149,110.258,401.703,110.705,401.152,110.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E",
      stroke: "#2A3E5E",
      strokeWidth: 0.2345,
      strokeMiterlimit: 10
    },
    d: "M363.907,110.705h-1.663 c-0.551,0-0.998-0.447-0.998-0.998l0,0c0-0.551,0.447-0.998,0.998-0.998h1.663c0.551,0,0.998,0.447,0.998,0.998l0,0 C364.905,110.258,364.458,110.705,363.907,110.705z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M361.691,103.444c0-1.408-1.142-2.55-2.55-2.55c-1.408,0-2.55,1.142-2.55,2.55 c0,1.408,1.142,2.55,2.55,2.55C360.549,105.994,361.691,104.853,361.691,103.444z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#255254"
    },
    cx: 356.813,
    cy: 93.468,
    r: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M360.138,96.794c0-0.49-0.397-0.887-0.887-0.887c-0.49,0-0.887,0.397-0.887,0.887 c0,0.49,0.397,0.887,0.887,0.887C359.741,97.68,360.138,97.283,360.138,96.794z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#255254"
    },
    cx: 360.138,
    cy: 91.473,
    r: 0.887
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#255254"
    },
    cx: 362.577,
    cy: 94.798,
    r: 0.887
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M401.816,103.444c0-1.408,1.142-2.55,2.55-2.55c1.408,0,2.55,1.142,2.55,2.55 c0,1.408-1.142,2.55-2.55,2.55C402.958,105.994,401.816,104.853,401.816,103.444z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M405.807,93.468c0-0.49,0.397-0.887,0.887-0.887c0.49,0,0.887,0.397,0.887,0.887 c0,0.49-0.397,0.887-0.887,0.887C406.204,94.355,405.807,93.958,405.807,93.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M403.369,96.794c0-0.49,0.397-0.887,0.887-0.887s0.887,0.397,0.887,0.887 c0,0.49-0.397,0.887-0.887,0.887S403.369,97.283,403.369,96.794z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#255254"
    },
    cx: 403.369,
    cy: 91.473,
    r: 0.887
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#255254"
    },
    cx: 400.93,
    cy: 94.798,
    r: 0.887
  }))))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 359.7736 130.192)",
    style: {
      fill: "#2A3E5E",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 12
    }
  }, "Gamer")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1588 -0.9873 0.9873 0.1588 60.2574 596.4994)",
    style: {
      fill: "#84C1C4"
    },
    cx: 380.18,
    cy: 262.888,
    rx: 31.658,
    ry: 31.658
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -80.8781 344.0236)",
    style: {
      opacity: 0.52,
      fill: "none",
      stroke: "#84C1C4",
      strokeWidth: 1.2205,
      strokeMiterlimit: 10,
      strokeDasharray: 1.5282
    },
    cx: 374.834,
    cy: 269.64,
    rx: 31.658,
    ry: 31.658
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B938"
    },
    d: "M363.159,268.444c0.6-8.262,2.538-16.425,5.71-24.077c0.346-0.834,1.456-1.028,2.069-0.366 c1.07,1.154,1.85,2.579,2.227,4.108c0.166,0.673,0.32,1.456,0.929,1.788c0.36,0.196,0.794,0.177,1.203,0.158 c3.747-0.176,7.512,0.054,11.21,0.684c1.008-2.711,1.5-4.268,2.697-6.9c0.416-0.915,1.302-0.748,1.58-0.748 c0.314,0,1.134,0.538,1.247,0.831c2.773,7.19,4.275,13.649,5.898,21.182c0.259,1.203,0.499,2.479,0.097,3.642 c-0.334,0.963-1.071,1.727-1.833,2.404c-4.822,4.275-11.444,6.222-17.885,6.039c-5.636-0.16-11.75-2.301-14.393-7.281"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED842E"
    },
    d: "M369.232,250.822c0.128-1.384,0.421-2.753,0.872-4.067c0.696,1.135,1.293,2.33,1.781,3.567 c-0.789,0.468-1.666,0.787-2.572,0.936"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED842E"
    },
    d: "M388.715,250.706c0.316-1.239,0.858-2.42,1.59-3.468c0.733,1.247,1.22,2.638,1.426,4.069 c-0.92-0.166-1.846-0.296-2.777-0.388"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M378.594,265.755c0.955-0.219,1.931-0.346,2.91-0.38c0.486-0.017,0.999-0.003,1.416,0.245 c0.07,0.042,0.139,0.092,0.179,0.163c0.043,0.077,0.048,0.169,0.043,0.257c-0.029,0.594-0.412,1.103-0.779,1.57 c-0.261,0.332-0.523,0.666-0.83,0.957c-0.219,0.208-0.507,0.405-0.8,0.334c-0.14-0.034-0.258-0.125-0.366-0.219 c-0.809-0.707-1.282-1.712-1.734-2.687"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M380.456,268.852c0.276,0.679-0.139,1.441-0.872,1.549 c-0.741,0.109-1.376-0.501-1.387-1.232c-0.005-0.349-0.548-0.35-0.542,0c0.012,0.791,0.551,1.552,1.338,1.736 c0.768,0.18,1.614-0.173,1.94-0.91c0.179-0.404,0.214-0.873,0.046-1.288c-0.055-0.135-0.18-0.231-0.333-0.189 C380.516,268.554,380.4,268.716,380.456,268.852L380.456,268.852z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M380.651,269.042c-0.062,0.798,0.504,1.602,1.297,1.766c0.817,0.17,1.634-0.255,1.94-1.033 c0.17-0.432,0.139-0.911-0.047-1.331c-0.06-0.134-0.254-0.165-0.371-0.097c-0.138,0.081-0.157,0.236-0.097,0.371 c0.14,0.315,0.11,0.708-0.054,1.008c-0.171,0.313-0.475,0.514-0.827,0.568c-0.742,0.114-1.355-0.523-1.298-1.252 c0.011-0.146-0.133-0.271-0.271-0.271C380.766,268.771,380.662,268.896,380.651,269.042L380.651,269.042z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M377.98,261.407c0,2.847-1.092,5.154-2.439,5.154c-1.347,0-2.439-2.308-2.439-5.154 s1.092-5.154,2.439-5.154C376.889,256.253,377.98,258.56,377.98,261.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M377.913,262.322c0,2.347-0.9,4.25-2.011,4.25c-1.111,0-2.011-1.903-2.011-4.25 c0-2.347,0.9-4.25,2.011-4.25C377.012,258.072,377.913,259.974,377.913,262.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.622,261.407c0,2.847-1.092,5.154-2.439,5.154c-1.347,0-2.439-2.308-2.439-5.154 s1.092-5.154,2.439-5.154C387.53,256.253,388.622,258.56,388.622,261.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M388,262.432c0,2.347-0.9,4.25-2.011,4.25c-1.111,0-2.011-1.903-2.011-4.25 s0.9-4.25,2.011-4.25C387.1,258.182,388,260.085,388,262.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M387.474,269.117c0.821-1.146,1.765-2.454,3.254-2.709c1.56-0.266,2.19,1.077,3.221,1.917 c0.914,0.745,2.163,0.937,3.25,0.465c1.119-0.487,1.878-1.523,2.407-2.585c0.215-0.431-0.432-0.811-0.648-0.378 c-0.593,1.19-1.569,2.502-3.045,2.477c-1.483-0.024-2.068-1.384-3.127-2.154c-0.958-0.697-2.201-0.636-3.234-0.138 c-1.185,0.572-1.981,1.685-2.727,2.726C386.545,269.132,387.195,269.507,387.474,269.117L387.474,269.117z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M375.602,268.919c-1.621-1.245-4.689-3.53-6.61-1.647c-0.421,0.413-0.722,0.937-1.187,1.305 c-0.543,0.429-1.237,0.604-1.921,0.579c-1.489-0.055-2.698-1.078-3.539-2.23c-0.282-0.386-0.933-0.012-0.648,0.379 c1.39,1.903,3.982,3.516,6.284,2.066c1.164-0.733,1.573-2.342,3.222-2.017c1.453,0.287,2.869,1.327,4.021,2.212 C375.606,269.861,375.98,269.21,375.602,268.919L375.602,268.919z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M375.294,270.261c-2.495-0.499-5.195,0.779-6.338,3.068 c-0.215,0.431,0.432,0.811,0.648,0.379c0.987-1.976,3.312-3.158,5.491-2.723 C375.566,271.079,375.768,270.356,375.294,270.261L375.294,270.261z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M387.383,270.372c1.049-0.183,2.154-0.224,3.188,0.065c1.11,0.309,1.984,1.022,2.548,2.022 c0.237,0.421,0.885,0.043,0.648-0.379c-0.643-1.142-1.66-1.974-2.92-2.345c-1.189-0.351-2.455-0.297-3.663-0.087 C386.709,269.732,386.91,270.455,387.383,270.372L387.383,270.372z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M380.776,242.686c-2.006-1.578-4.355-3.853-5.965-5.834c-1.61-1.981-2.794-4.408-2.842-6.96 c-0.015-0.826,0.283-1.867,1.104-1.964c0.403-0.048,0.786,0.167,1.128,0.385c2.227,1.424,4.121,3.365,5.488,5.627 c-0.267-2.42,1.26-4.927,3.533-5.799c0.313-0.12,0.649-0.212,0.98-0.158c0.375,0.061,0.696,0.305,0.951,0.585 c0.883,0.969,1.114,2.397,0.913,3.693c-0.201,1.296-0.78,2.498-1.352,3.678c-1.199,2.474-2.398,4.949-3.597,7.423"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M381.041,242.42c-1.688-1.339-3.268-2.819-4.725-4.405c-1.481-1.612-2.828-3.373-3.51-5.482 c-0.306-0.946-0.564-2.034-0.446-3.034c0.07-0.595,0.326-1.342,1.085-1.158c0.484,0.117,1.015,0.584,1.41,0.872 c1.815,1.322,3.335,3.006,4.509,4.916c0.182,0.296,0.733,0.2,0.699-0.189c-0.152-1.724,0.526-3.42,1.834-4.563 c0.699-0.611,1.979-1.464,2.829-0.706c0.734,0.655,1.019,1.711,1.032,2.661c0.027,2.063-1.162,3.995-2.034,5.793 c-0.977,2.016-1.954,4.032-2.931,6.048c-0.21,0.432,0.437,0.813,0.648,0.378c1.281-2.643,2.583-5.277,3.841-7.93 c0.918-1.935,1.751-4.191,0.81-6.283c-0.346-0.769-0.995-1.619-1.891-1.73c-0.908-0.113-1.902,0.489-2.581,1.027 c-1.591,1.26-2.485,3.281-2.307,5.305c0.233-0.063,0.466-0.126,0.699-0.189c-1.333-2.168-3.091-4.044-5.196-5.48 c-0.782-0.533-1.823-1.132-2.624-0.284c-0.654,0.692-0.643,1.788-0.551,2.667c0.262,2.493,1.48,4.742,3.057,6.65 c1.718,2.079,3.701,3.972,5.812,5.647C380.885,243.248,381.419,242.72,381.041,242.42L381.041,242.42z"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 352.4577 288.4815)",
    style: {
      fill: "#2A3E5E",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 12
    }
  }, "Cat Lover"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M144.887,381.02c13.004,15.731,26.313,31.21,39.926,46.418 c3.889,4.345,7.803,8.668,11.741,12.97c0.358,0.391,0.937-0.191,0.581-0.581c-13.78-15.056-27.268-30.379-40.446-45.965 c-3.765-4.453-7.505-8.928-11.22-13.422C145.131,380.032,144.553,380.616,144.887,381.02L144.887,381.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M160.24,364.07c4.144,15.838,8.056,31.736,11.736,47.689 c0.119,0.515,0.911,0.297,0.792-0.218c-3.68-15.952-7.592-31.85-11.736-47.689 C160.899,363.341,160.106,363.557,160.24,364.07L160.24,364.07z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M131.37,381.633c9.805,5.587,19.456,11.441,28.941,17.555 c0.445,0.287,0.858-0.423,0.415-0.709c-9.485-6.114-19.136-11.968-28.941-17.555 C131.324,380.662,130.91,381.371,131.37,381.633L131.37,381.633z"
  })))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC94A"
    },
    cx: 130.934,
    cy: 380.765,
    r: 3.641
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M148.776,380.401c0-2.011-1.63-3.641-3.641-3.641c-2.011,0-3.641,1.63-3.641,3.641 c0,2.011,1.63,3.641,3.641,3.641C147.146,384.042,148.776,382.412,148.776,380.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M164.07,363.287c0-2.011-1.63-3.641-3.641-3.641c-2.011,0-3.641,1.63-3.641,3.641 c0,2.011,1.63,3.641,3.641,3.641C162.44,366.928,164.07,365.298,164.07,363.287z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7CFD1"
    },
    d: "M180.49,473.379c-20.023-12.283-39.109-28.993-45.591-51.572 c-1.312-4.572-1.652-10.421,2.248-13.144c3.813-2.663,9.06-0.504,12.941,2.057c19.938,13.158,39.999,39.431,39.901,63.32"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.987,473.185c-5.082-8.976-10.911-17.53-17.025-25.83 c-6.487-8.805-13.354-17.349-20.671-25.48c-3.71-4.124-7.544-8.141-11.579-11.949c-0.351-0.331-0.882,0.198-0.53,0.53 c7.449,7.031,14.263,14.734,20.756,22.647c6.982,8.509,13.596,17.337,19.719,26.484c3.051,4.558,5.979,9.202,8.682,13.975 C186.577,473.984,187.225,473.606,186.987,473.185L186.987,473.185z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7CFD1"
    },
    d: "M202.453,474.687c-5.652-7.281-10.78-14.968-15.333-22.982 c-1.628-2.867-3.236-6.079-2.611-9.316c0.543-2.813,2.671-5.04,3.741-7.698c2.394-5.942-0.815-12.494-3.497-18.311 c-7.95-17.242-11.76-36.376-11.021-55.349c0.247-6.349,2.639-14.385,8.978-14.821c3.007-0.207,5.778,1.544,8.15,3.403 c13.253,10.384,21.377,25.816,29.114,40.769c12.839,24.815,25.791,49.923,32.434,77.061c0.486,1.986,2.373,5.901,2.091,7.927"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.54
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.347,473.182c-7.229-14.376-14.808-28.574-22.74-42.574 c-7.893-13.931-16.13-27.667-24.703-41.19c-4.856-7.661-9.822-15.252-14.89-22.775c-0.268-0.398-0.918-0.023-0.648,0.379 c8.99,13.345,17.654,26.909,25.971,40.683c8.277,13.706,16.215,27.617,23.803,41.716 c4.299,7.987,8.484,16.035,12.559,24.139C242.916,473.992,243.563,473.612,243.347,473.182L243.347,473.182z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.847,449.595c-14.399-3.858-29.153-6.29-44.028-7.263c-0.482-0.031-0.48,0.719,0,0.75 c14.81,0.969,29.493,3.395,43.828,7.236C232.115,450.444,232.314,449.72,231.847,449.595L231.847,449.595z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M190.885,419.277c11.139,6.334,22.278,12.668,33.417,19.002 c0.42,0.239,0.799-0.409,0.379-0.648c-11.139-6.334-22.278-12.668-33.417-19.002 C190.843,418.391,190.465,419.039,190.885,419.277L190.885,419.277z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M352.782,374.73c-9.987,17.522-19.632,35.238-28.921,53.139 c-2.622,5.053-5.215,10.121-7.781,15.202c-0.234,0.464,0.464,0.874,0.699,0.408c9.091-18.003,18.533-35.828,28.326-53.459 c2.764-4.976,5.557-9.937,8.376-14.883C353.74,374.685,353.04,374.277,352.782,374.73L352.782,374.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M373.777,382.979c-13.831,9.834-27.56,19.822-41.673,29.25 c-0.431,0.288-0.026,0.989,0.409,0.699c14.113-9.428,27.843-19.416,41.673-29.25 C374.607,383.379,374.203,382.677,373.777,382.979L373.777,382.979z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M354.691,378.136c1.853-0.702,2.787-2.773,2.085-4.627c-0.702-1.853-2.773-2.787-4.627-2.085 c-1.853,0.702-2.787,2.773-2.085,4.627C350.766,377.904,352.837,378.837,354.691,378.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M375.801,386.258c1.853-0.702,2.787-2.773,2.085-4.627c-0.702-1.853-2.773-2.787-4.627-2.085 c-1.853,0.702-2.787,2.773-2.085,4.627C371.876,386.026,373.947,386.96,375.801,386.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7CFD1"
    },
    d: "M331.645,475.374c20.023-12.283,39.109-28.993,45.591-51.572 c1.313-4.572,1.652-10.421-2.247-13.144c-3.813-2.663-9.06-0.504-12.942,2.058c-19.938,13.158-41.801,38.766-41.702,62.655"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.989,474.229c4.945-8.73,10.698-17,16.742-25c6.552-8.673,13.516-17.049,20.882-25.044 c3.716-4.034,7.543-7.968,11.533-11.733c0.352-0.332-0.179-0.862-0.53-0.53c-7.404,6.986-14.283,14.53-20.847,22.305 c-6.961,8.246-13.582,16.802-19.676,25.71c-3.094,4.523-6.05,9.144-8.752,13.913 C325.103,474.271,325.751,474.649,325.989,474.229L325.989,474.229z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7CFD1"
    },
    d: "M309.016,474.687c5.652-7.281,10.78-14.968,15.333-22.982c1.629-2.867,3.236-6.079,2.611-9.316 c-0.543-2.813-2.671-5.04-3.741-7.698c-2.394-5.942,0.815-12.494,3.497-18.311c7.95-17.242,11.76-36.376,11.021-55.349 c-0.247-6.349-2.639-14.385-8.978-14.821c-3.007-0.207-5.778,1.544-8.15,3.403c-13.253,10.384-21.377,25.816-29.114,40.769 c-12.839,24.815-25.791,49.923-32.434,77.061c-0.486,1.986-1.515,5.236-1.233,7.262"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.54
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.77,473.56c7.229-14.375,14.808-28.574,22.74-42.574 c7.893-13.931,16.13-27.667,24.703-41.19c4.856-7.661,9.822-15.253,14.89-22.775c0.27-0.401-0.379-0.777-0.648-0.379 c-8.99,13.345-17.654,26.909-25.971,40.683c-8.277,13.706-16.215,27.617-23.803,41.716 c-4.299,7.987-8.484,16.036-12.559,24.139C267.906,473.612,268.553,473.992,268.77,473.56L268.77,473.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.821,450.318c14.336-3.841,29.019-6.267,43.829-7.236c0.479-0.031,0.483-0.782,0-0.75 c-14.875,0.973-29.629,3.405-44.028,7.263C279.156,449.72,279.354,450.444,279.821,450.318L279.821,450.318z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.57,419.806c-12.584,5.193-24.938,11.106-36.781,17.825 c-0.42,0.238-0.042,0.886,0.378,0.648c11.785-6.687,24.078-12.582,36.602-17.75 C324.21,420.348,324.017,419.622,323.57,419.806L323.57,419.806z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C75A64"
    },
    points: "279.869,459.6 277.554,455.025 263.765,455.523 263.456,459.6 269.934,470.84  281.596,461.848  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#822E3A"
    },
    d: "M271.457,455.484l-2.656,16.56c-0.136,0.928-0.525-3.363-0.878-4.232 c-0.971-2.392-2.549-5.464-4.814-7.494l0.575-6.012L271.457,455.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M280.701,459.443l-9.905,10.274c0,0-5.903-9.038-7.202-10.173 c-0.264-0.231-0.623-0.024-0.668,0.386l-1.63,14.844h41.033c0.477,0,0.864-0.503,0.864-1.124v-3.124 c0-0.484-0.238-0.913-0.591-1.066L280.701,459.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C75A64"
    },
    points: "213.014,459.6 210.7,455.025 198.045,453.127 196.601,459.6 203.08,470.84  214.742,461.848  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#822E3A"
    },
    d: "M203.227,455.189l-1.932,16.19c0,0-0.501-8.192-4.688-11.945l1.151-5.129L203.227,455.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M213.847,459.443c0,0-4.846,6.033-9.559,9.609c-2.806,2.128-6.249-8.373-7.548-9.508 c-0.265-0.231-0.624-0.024-0.668,0.386l-1.63,14.844h41.033c0.477,0,0.864-0.503,0.864-1.124v-3.124 c0-0.484-0.238-0.913-0.59-1.066L213.847,459.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#255254"
    },
    d: "M277.307,279.931c0,0,5.277,63.123,5.773,80.563c0.496,17.44-3.005,95.192-3.005,95.192 l-16.928,0.063c0,0-20.36-130.113-41.681-172.176L277.307,279.931z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5825,
      strokeMiterlimit: 10
    },
    x1: 267.803,
    y1: 438.458,
    x2: 267.915,
    y2: 455.52
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5825,
      strokeMiterlimit: 10
    },
    d: "M250.683,283.262 c0,0,15.016,72.923,15.016,84.12c0,1.8,2.008,60.486,2.104,65.09"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5825,
      strokeMiterlimit: 10
    },
    x1: 262.482,
    y1: 448.101,
    x2: 280.265,
    y2: 447.583
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28787C"
    },
    d: "M269.466,279.503c0,0-4.316,53.046-16.709,90.273c-10.015,30.083-39.823,86.307-39.823,86.307 l-16.99,0.77l21.379-86.183c1.138-4.489,1.856-9.078,2.148-13.71c1.099-17.48-2.494-52.804-3.996-75.437L269.466,279.503z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5825,
      strokeMiterlimit: 10
    },
    d: "M232.554,367.626 c-9.097,28.875-27.823,89.069-27.823,89.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5825,
      strokeMiterlimit: 10
    },
    d: "M234.599,280.911 c0,0,5.765,68.203,0.583,78.81"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5825,
      strokeMiterlimit: 10
    },
    x1: 198.412,
    y1: 449.053,
    x2: 216.592,
    y2: 450.096
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C75A64"
    },
    d: "M328.99,202.52c3.479-9.415,11.805-27.268,11.805-27.268l6.653-17.46 c0.616-1.616,0.081-3.43-1.28-4.497c-5-3.92-12.315-3.953-13.748-2.289c-0.409,0.475-2.041,5.763-3.271,6.349 c-1.23,0.585-8.59-7.039-9.734-4.637c-0.64,1.343,7.719,12.325,7.719,12.325c-1.861,3.561-5.12,8.845-5.12,8.845L328.99,202.52 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83B4B"
    },
    d: "M331.899,153.525l11.35,6.577c0.43,0.219-0.177,0.294-0.273,0.767 c-1.182,5.792-10.161,5.293-12.378-4.406L331.899,153.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C75A64"
    },
    d: "M308.545,196.628c0,0-59.47-39.675-66.014-12.163c-3.36,14.128,57.239,40.299,75.654,44.176 c2.143,0.451,4.288-0.752,5.062-2.801l17.714-51.088l-14.759-7.93L308.545,196.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M308.545,196.628c0,0-57.255-46.949-63.799-19.437c-3.361,14.128,35.191,55.185,74.046,52.098 c2.183-0.174,4.288-0.752,5.062-2.801l17.107-51.736l-14.759-7.93L308.545,196.628z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M308.545,196.628c0,0-57.255-46.949-63.799-19.437c-3.361,14.128,34.784,55.99,73.639,52.903 c2.183-0.173,4.288-0.752,5.062-2.8l17.514-52.542l-14.759-7.93L308.545,196.628z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060007012365742289690000008552487315042999485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060007012365742289690000008552487315042999485_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.351,170.525c7.408,5.731,9.859,15.22,13.725,23.315 c1.882,3.942,4.17,7.945,7.796,10.535c3.66,2.614,8.147,2.803,11.99,0.436c4.941-3.043,7.098-8.647,9.017-13.84 c0.168-0.453-0.557-0.649-0.723-0.199c-1.758,4.755-3.685,9.929-8.012,12.957c-4.218,2.951-9.155,2.479-12.976-0.864 c-3.269-2.86-5.302-6.859-7.074-10.753c-1.721-3.783-3.181-7.683-5.027-11.41c-2.018-4.075-4.556-7.898-8.187-10.708 C268.504,169.702,267.97,170.229,268.351,170.525L268.351,170.525z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290.068,225.224c2.067-7.326,9.649-11.894,17.099-10.002 c3.267,0.829,6.241,3.203,9.735,3.019c2.93-0.154,5.175-2.197,7.295-4.003c3.423-2.917,7.335-4.68,11.886-4.698 c0.483-0.002,0.483-0.752,0-0.75c-3.718,0.015-7.381,1.126-10.408,3.307c-2.789,2.01-5.268,5.273-8.977,5.398 c-2.079,0.07-4.044-0.908-5.897-1.723c-1.61-0.708-3.229-1.331-4.981-1.577c-3.506-0.492-7.178,0.252-10.159,2.182 c-3.093,2.003-5.32,5.111-6.317,8.646C289.213,225.49,289.936,225.688,290.068,225.224L290.068,225.224z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M320.099,168.606c-2.039,7.49-2.651,16.118,1.313,23.116 c3.278,5.788,9.733,10.103,16.553,9.24c0.472-0.06,0.478-0.811,0-0.75c-6.695,0.847-12.983-3.442-16.084-9.191 c-3.659-6.785-3.016-15.027-1.059-22.216C320.949,168.339,320.226,168.14,320.099,168.606L320.099,168.606z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.245,170.456c1.499,5.191,4.432,10.013,8.808,13.264 c4.563,3.39,10.54,4.757,16.067,3.288c0.466-0.124,0.268-0.848-0.199-0.723c-5.341,1.42-11.09,0.068-15.49-3.213 c-4.209-3.138-7.021-7.822-8.463-12.816C323.835,169.793,323.111,169.99,323.245,170.456L323.245,170.456z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#FFC94A"
    },
    d: "M287.656,202.921c-7.651-13.405-17.97-24.863-30.116-34.292 c-6.319-0.553-11.152,1.662-12.793,8.562c-2.776,11.671,22.638,41.277,53.467,49.479 C295.392,218.471,291.978,210.491,287.656,202.921z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M203.055,196.848c0.591-14.863,24.318-28.235,24.318-28.235l8.355-5.898l-0.066,0.465 l14.849,12.237l4.549-3.924l-0.246-2.548l4.482,1.516c1.917,0.239,10.767,9.96,13.649,14.46 c3.121,4.873,4.915,10.508,5.194,16.328l9.172,100.09l-77.15,2.66C210.162,304,202.145,219.722,203.055,196.848z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005250210616714057170000000730869116194306744_",
    d: "M203.055,196.848 c0.591-14.863,24.318-28.235,24.318-28.235l8.355-5.898l-0.066,0.465l14.849,12.237l4.549-3.924l-0.246-2.548l4.482,1.516 c1.917,0.239,10.767,9.96,13.649,14.46c3.121,4.873,4.915,10.508,5.194,16.328l9.172,100.09l-77.15,2.66 C210.162,304,202.145,219.722,203.055,196.848z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041288945881119202190000006867275192023044539_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005250210616714057170000000730869116194306744_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041288945881119202190000006867275192023044539_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M222.291,166.268c4.599,6.902,12.456,10.658,17.255,17.366 c5.493,7.678,5.057,17.584,4.777,26.569c-0.237,7.571-0.175,15.42,3.077,22.436c1.442,3.111,3.565,5.915,6.404,7.876 c2.962,2.046,6.475,2.953,10.011,3.359c8.169,0.937,18.332-1.129,24.871,5.081c0.35,0.332,0.881-0.197,0.53-0.53 c-5.418-5.145-13.31-4.742-20.258-4.965c-3.787-0.122-7.682-0.364-11.254-1.739c-3.651-1.405-6.583-4.042-8.57-7.391 c-8.817-14.858,0.576-33.308-7.279-48.37c-4.379-8.396-13.749-12.316-18.917-20.071 C222.673,165.49,222.023,165.865,222.291,166.268L222.291,166.268z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M205.99,286.63c12.576-2.998,22.527-11.573,33.414-18.019 c5.699-3.374,11.825-6.299,18.404-7.415c6.657-1.13,13.262,0.055,19.338,2.911c6.461,3.037,12.128,7.494,17.674,11.927 c0.373,0.298,0.908-0.229,0.53-0.53c-9.72-7.769-20.637-16.141-33.775-15.473c-13.46,0.684-24.632,9.282-35.51,16.299 c-6.309,4.07-12.911,7.822-20.274,9.577C205.322,286.019,205.52,286.742,205.99,286.63L205.99,286.63z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.484,175.935c1.633,3.975,2.367,8.222,3.746,12.279c1.168,3.436,2.924,6.549,5.355,9.25 c4.895,5.438,11.582,8.88,18.022,12.131c0.43,0.217,0.81-0.43,0.378-0.648c-6.278-3.17-12.78-6.503-17.616-11.736 c-2.629-2.844-4.438-6.147-5.623-9.825c-1.246-3.868-1.991-7.881-3.539-11.65 C252.026,175.296,251.301,175.488,251.484,175.935L251.484,175.935z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M286.582,271.144c-6.108,2.886-10.815,8.192-13.298,14.444 c-1.24,3.122-1.909,6.484-1.892,9.846c0.009,1.651,0.038,3.634,0.702,5.171c0.715,1.654,2.649,2.595,4.084,3.524 c4.217,2.728,8.633,5.131,13.2,7.219c0.436,0.199,0.817-0.447,0.379-0.648c-3.598-1.645-7.104-3.482-10.491-5.526 c-1.675-1.011-3.363-2.042-4.95-3.188c-1.896-1.369-2.061-3.489-2.153-5.661c-0.274-6.511,2.125-13.05,6.324-18.005 c2.336-2.756,5.207-4.984,8.474-6.528C287.396,271.586,287.016,270.939,286.582,271.144L286.582,271.144z"
  })))))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.53
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M231.616,253.058c-5.534-11.031-10.558-22.349-15.43-33.687 c-4.31-10.028-8.226-20.211-10.533-30.878c-1.501,2.673-2.484,5.485-2.598,8.354C202.145,219.722,210.162,304,210.162,304 l50.811-1.752C250.055,286.559,240.197,270.161,231.616,253.058z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C75A64"
    },
    d: "M265.995,123.538c0,0,2.91,21.319-2.005,31.436c-0.645,1.328-1.972,2.186-3.445,2.3 c-2.503,0.193-4.964-0.055-6.204-0.212c-0.14-0.958-1.196,7.308,0.924,14.477l-0.003,0.062 c-0.211,4.594-5.85,6.665-8.985,3.299l-9.93-10.664c0,0,1.662-12.503,1.977-16.723c0.168-2.255,0.218-4.466,0.026-5.647 c-2.657-0.231-3.436-5.15-2.433-7.817c0.956-2.544,5.826-2.357,6.739-0.084c0.29,0.723,1.128,1.482,2.038,0.398 c0.779-0.928,0.91-8.97,2.974-10.055c7.005,1.108,13.553,0.616,15.812,0C265.593,123.732,265.995,123.538,265.995,123.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#822E3A"
    },
    d: "M236.578,136.167c1.232-4.826,4.518-1.027,4.518-1.027L236.578,136.167z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#822E3A"
    },
    points: "255.881,157.267 249.567,156.343 254.957,172.514  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83B4B"
    },
    d: "M260.154,137.258c0,0,2.356,6.995,2.078,6.983c-0.731-0.031-2.411-0.083-2.411-0.083 L260.154,137.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020F2B"
    },
    d: "M261.774,139.013c0.01,0.715,0.297,1.291,0.643,1.286c0.345-0.005,0.617-0.588,0.607-1.303 c-0.01-0.715-0.297-1.291-0.643-1.286C262.036,137.715,261.764,138.298,261.774,139.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020F2B"
    },
    d: "M256.121,139.179c0.01,0.715,0.297,1.291,0.643,1.286c0.345-0.005,0.617-0.588,0.607-1.303 c-0.01-0.715-0.297-1.291-0.643-1.286C256.383,137.881,256.111,138.464,256.121,139.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M252.802,134.421c-0.822,0.113,0.129-1.758,3.433-2.411c1.164-0.23,1.995,1.014,1.475,1.922 C257.371,134.524,255.78,134.01,252.802,134.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M265.392,132.603c0.795,0.239,0.169-2.169-2.192-2.887c-1.647-0.501-2.053,0.924-1.438,1.951 C262.078,132.193,264.139,132.225,265.392,132.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264.062,145.572l-8.563-0.333c0,0,1.893,3.571,4.357,3.674 C261.839,148.996,264.062,145.572,264.062,145.572z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M238.365,146.622c-0.621,0.155-1.263-0.299-1.542-0.874c-0.279-0.576-0.283-1.241-0.281-1.881 c-1.104,0.232-2.08-0.748-2.66-1.716c-1.506-2.51-2.001-5.563-1.609-8.463c0.392-2.901,1.635-5.65,3.354-8.019 c0.238-0.328,0.491-0.661,0.594-1.054c0.153-0.583-0.049-1.194-0.246-1.764c-0.707-2.047-1.39-4.155-1.344-6.32 c0.046-2.165,0.952-4.431,2.797-5.565s4.658-0.694,5.658,1.227c-0.141-2.438,1.823-4.72,4.202-5.27 c2.379-0.55,4.961,0.462,6.619,2.254c0.745-1.369,1.559-2.809,2.922-3.566c1.845-1.024,4.301-0.441,5.82,1.024 c1.519,1.464,2.202,3.628,2.293,5.736c1.37-0.501,3.066-0.334,4.065,0.729c0.999,1.063,0.907,3.069-0.367,3.778 c1.138,0.728,2.066,1.85,2.36,3.169c0.294,1.319-0.129,2.824-1.2,3.648c-1.071,0.825-2.773,0.79-3.686-0.206 c0.029,0.675,0.033,1.376-0.243,1.993c-0.276,0.617-0.909,1.125-1.579,1.042c-1.02-0.125-1.422-1.365-1.599-2.378 c-0.437,1.002-1.44,1.641-2.456,2.046c-3.635,1.446-8.115,0.42-10.757-2.465c0.304,1.133-0.913,2.366-2.05,2.076 c1.359,2.52,1.037,5.847-0.781,8.059c-0.681,0.828-1.738,1.545-2.767,1.242c-0.95-0.28-1.451-1.287-2.16-1.978 c-0.914-0.892-2.294-1.276-3.537-0.985c-1.243,0.291-2.309,1.248-2.732,2.453c-0.458,1.304-0.18,2.743,0.165,4.081 c0.312,1.212,0.823,2.574,2.005,2.987c0.246,0.086,0.529,0.136,0.692,0.339c0.148,0.184,0.154,0.441,0.153,0.678 c-0.005,1.13-0.011,2.259-0.016,3.389"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E5E"
    },
    d: "M238.365,146.247c-1.333,0.124-1.444-1.42-1.449-2.38c-0.001-0.189-0.172-0.394-0.375-0.375 c-2.094,0.197-3.159-2.908-3.586-4.507c-0.487-1.821-0.56-3.752-0.26-5.611c0.272-1.687,0.838-3.322,1.613-4.842 c0.381-0.747,0.81-1.467,1.281-2.16c0.364-0.535,0.85-1.058,0.999-1.707c0.332-1.447-0.733-3.207-1.093-4.579 c-0.48-1.828-0.727-3.768-0.168-5.608c0.494-1.626,1.62-3.188,3.34-3.628c1.547-0.396,3.267,0.12,4.094,1.532 c0.186,0.317,0.705,0.186,0.699-0.189c-0.039-2.268,1.574-4.28,3.758-4.863c2.362-0.632,4.78,0.427,6.422,2.113 c0.165,0.17,0.474,0.135,0.589-0.076c1.325-2.42,3.16-4.652,6.212-3.636c2.804,0.933,3.959,3.923,4.124,6.64 c0.014,0.232,0.23,0.441,0.475,0.362c1.148-0.37,2.53-0.402,3.485,0.448c0.988,0.879,1.104,2.592-0.075,3.374 c-0.244,0.162-0.238,0.485,0,0.648c1.44,0.983,2.583,2.604,2.186,4.429c-0.418,1.923-2.689,3.067-4.258,1.593 c-0.228-0.214-0.65-0.07-0.64,0.265c0.024,0.793-0.204,3.67-1.944,2.393c-0.497-0.365-0.632-1.272-0.741-1.835 c-0.061-0.314-0.542-0.367-0.685-0.09c-1.119,2.165-4.226,2.659-6.436,2.476c-2.36-0.195-4.557-1.264-6.187-2.972 c-0.284-0.297-0.678,0.024-0.627,0.365c0.136,0.911-0.672,1.74-1.589,1.615c-0.323-0.044-0.582,0.237-0.424,0.551 c0.804,1.596,1.002,3.409,0.527,5.138c-0.435,1.585-2.289,4.855-4.311,3.225c-1.001-0.807-1.466-1.889-2.738-2.388 c-1.1-0.432-2.347-0.386-3.402,0.15c-2.584,1.313-2.576,4.197-1.927,6.658c0.278,1.053,0.674,2.232,1.596,2.899 c0.644,0.466,1.088,0.294,1.239,1.248c0.155,0.978-0.01,2.157-0.015,3.147c-0.002,0.483,0.748,0.483,0.75,0 c0.005-0.968,0.023-1.937,0.014-2.905c-0.004-0.47,0.073-1.034-0.26-1.427c-0.386-0.455-1.084-0.446-1.519-0.867 c-0.611-0.591-0.871-1.499-1.082-2.294c-0.513-1.935-0.744-4.253,1.131-5.549c1.9-1.313,3.812-0.287,5.118,1.252 c1.777,2.095,3.984,1.128,5.282-0.987c1.431-2.332,1.462-5.261,0.244-7.678c-0.141,0.184-0.282,0.367-0.423,0.551 c1.53,0.209,2.74-1.006,2.512-2.537c-0.209,0.122-0.418,0.243-0.627,0.365c1.859,1.947,4.393,3.087,7.083,3.215 c2.383,0.114,5.529-0.57,6.718-2.871c-0.228-0.03-0.457-0.06-0.685-0.09c0.226,1.162,0.8,2.819,2.292,2.647 c1.659-0.192,1.906-2.086,1.867-3.404c-0.213,0.088-0.427,0.177-0.64,0.265c1.7,1.597,4.356,0.895,5.271-1.192 c1.025-2.337-0.358-4.688-2.29-6.008c0,0.216,0,0.432,0,0.648c1.3-0.862,1.589-2.632,0.764-3.944 c-0.996-1.585-3.12-1.775-4.752-1.249c0.158,0.12,0.316,0.241,0.475,0.362c-0.187-3.066-1.53-6.331-4.675-7.363 c-3.399-1.116-5.56,1.243-7.059,3.981c0.196-0.025,0.393-0.051,0.589-0.076c-1.896-1.946-4.802-3.119-7.486-2.204 c-2.335,0.796-4.018,3-3.975,5.485c0.233-0.063,0.466-0.126,0.699-0.189c-1.572-2.685-5.373-2.535-7.338-0.393 c-2.85,3.108-1.727,7.573-0.533,11.12c0.306,0.908,0.509,1.486,0.002,2.417c-0.26,0.477-0.65,0.909-0.944,1.37 c-0.6,0.943-1.119,1.934-1.549,2.965c-0.776,1.86-1.242,3.855-1.276,5.874c-0.034,2.016,0.357,4.043,1.203,5.877 c0.668,1.448,1.751,3.18,3.568,3.008c-0.125-0.125-0.25-0.25-0.375-0.375c0.006,1.4,0.398,3.298,2.199,3.13 C238.842,146.953,238.846,146.202,238.365,146.247L238.365,146.247z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2A3E5E",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M235.983,124.512c-1.617-2.133-2.583-3.887-2.931-6.541c-0.077-0.588,0.133-2.434,0.332-2.993 c0.831-2.328,1.481-2.674,3.205-3.181c1.725-0.506,3.564-0.357,5.355-0.201"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2A3E5E",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M235.297,124.788c-2.861,2.284-4.718,6.558-4.739,9.893c-0.021,3.457,0.98,7.33,3.786,9.35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2A3E5E",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M265.243,111.511c0.689-0.36,1.409-0.729,2.187-0.751c1.226-0.035,2.337,0.824,2.96,1.88c0.489,0.83,0.742,1.822,0.576,2.771 c-0.166,0.949-0.788,1.836-1.679,2.203"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2A3E5E",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M254.731,108.427c-0.783-0.99-1.898-1.667-3.049-2.186c-0.911-0.41-1.88-0.739-2.879-0.75 c-1.408-0.016-2.746,0.599-3.957,1.317"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.25,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M241.727,112.483 c-1.5-0.157-3.016,0.635-3.898,1.857c-0.882,1.223-1.167,2.816-0.954,4.309s0.892,2.89,1.775,4.113"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.25,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M251.287,123.103 c1.67,2.015,4.41,3.027,7.016,2.779c1.045-0.099,2.091-0.395,2.948-1.001c0.858-0.605,1.509-1.546,1.621-2.59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.25,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M255.031,121.854 c0.684,0.857,1.855,1.296,2.935,1.1c1.128-0.205,2.057-1.032,2.698-1.983"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.25,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M256.245,108.819 c0.917-1.24,2.33-1.489,3.536-1.311c0.795,0.117,1.504,0.544,2.111,1.071c1,0.868,1.15,1.446,1.422,2.742"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C75A64"
    },
    d: "M177.352,242.813c-8.585-5.734-28.181-12.834-28.181-12.834s-24.678-17.803-24.232-19.407 c0.446-1.604,9.515,2.245,9.515,2.245c-0.743-1.444-9.069-6.416-8.771-7.378c0.297-0.962,10.852,4.812,11.298,4.33 c0.446-0.481-10.555-6.416-9.96-7.699c0.595-1.283,11.596,4.651,12.19,4.331c0.595-0.321-10.407-6.897-9.069-8.019 c1.338-1.123,16.65,10.586,17.988,10.265c1.338-0.321-3.568-7.378-3.419-10.586c0.149-3.208,11.299,12.671,11.299,12.671 c2.89,2.546,30.653,12.572,30.653,12.572L177.352,242.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83B4B"
    },
    d: "M146.652,208.118l4.163,7.699c0,0-2.059-7.901-1.613-8.543L146.652,208.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC94A"
    },
    d: "M193.314,221.973c0,0,8.196-58.958,38.575-54.98c16.261,2.13-9.657,88.28-18.622,95.328 l-61.188-30.15l7.981-24.386L193.314,221.973z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000049910676039565443200000013919276732030561192_",
    d: "M193.314,221.973c0,0,8.196-58.958,38.575-54.98 c16.261,2.13-9.657,88.28-18.622,95.328l-61.188-30.15l7.981-24.386L193.314,221.973z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065781673654272048120000002670515010531508115_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049910676039565443200000013919276732030561192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065781673654272048120000002670515010531508115_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.644,205.03c4.022,2.346,8.317,4.854,10.595,9.094c1.132,2.106,1.698,4.559,1.182,6.928 c-0.427,1.964-1.517,3.687-2.693,5.284c-2.257,3.066-4.981,5.936-5.544,9.859c-0.515,3.592,0.638,7.255,3.08,9.926 c0.326,0.357,0.856-0.174,0.53-0.53c-2.388-2.613-3.438-6.256-2.796-9.743c0.589-3.2,2.761-5.719,4.685-8.22 c1.734-2.255,3.399-4.699,3.649-7.615c0.259-3.024-0.988-6.011-2.82-8.361c-2.483-3.185-6.057-5.268-9.49-7.27 C161.605,204.139,161.227,204.787,161.644,205.03L161.644,205.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.332,210.88c1.137,8.845,2.523,17.959,6.682,25.965 c3.662,7.049,11.221,15.67,20.153,13.279c4.037-1.081,7.318-4.176,9.625-7.55c2.397-3.507,4.083-8.03,3.104-12.306 c-0.473-2.067-1.636-3.75-2.911-5.404c-1.426-1.851-3.052-3.826-3.02-6.296c0.035-2.687,1.653-5.041,2.659-7.441 c0.902-2.153,1.399-4.455,1.532-6.783c0.655-11.451-6.732-20.957-14.098-28.881c-0.329-0.354-0.859,0.177-0.53,0.53 c6.415,6.901,12.771,14.767,13.784,24.488c0.248,2.378,0.163,4.805-0.358,7.142c-0.549,2.466-1.738,4.608-2.725,6.907 c-0.751,1.749-1.268,3.608-0.859,5.512c0.382,1.778,1.482,3.273,2.568,4.687c1.323,1.722,2.655,3.399,3.187,5.551 c0.553,2.234,0.282,4.583-0.411,6.754c-1.337,4.188-4.267,8.169-7.939,10.606c-8.616,5.718-17.426-1.65-21.891-8.997 c-5.056-8.32-6.582-18.266-7.803-27.763C180.022,210.408,179.271,210.402,179.332,210.88L179.332,210.88z"
  }))))))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#255254",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 80.737,
    y1: 474.704,
    x2: 419.263,
    y2: 474.704
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C75A64"
    },
    d: "M332.802,151.137c-0.465,1.319-0.931,2.639-1.396,3.958c-0.181,0.513-0.365,1.04-0.357,1.584 c0.007,0.544,0.244,1.119,0.721,1.381c0.627,0.344,1.434,0.035,1.946-0.464c0.512-0.499,0.833-1.159,1.28-1.717 c0.186,1.166-0.816,2.441-0.214,3.457c0.435,0.734,1.525,0.826,2.277,0.424c0.752-0.402,1.245-1.15,1.706-1.868 c-0.227,0.689-0.457,1.4-0.395,2.123c0.062,0.722,0.494,1.464,1.192,1.659c1.131,0.315,2.08-0.85,2.677-1.861 c-0.001,0.718,0.177,1.656,0.889,1.749c0.459,0.06,0.857-0.301,1.164-0.647c1.473-1.659,2.575-3.645,3.205-5.772"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83B4B"
    },
    d: "M334.2,158.181c-0.031-1.263,0.211-2.451,0.597-3.615c0.21-0.575,0.449-1.145,0.774-1.677 c0.318-0.532,0.704-1.042,1.213-1.429c-0.326,1.214-0.658,2.305-1.043,3.434C335.337,156.006,334.926,157.138,334.2,158.181z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83B4B"
    },
    d: "M338.08,159.954c0.098-1.227,0.367-2.349,0.765-3.471c0.213-0.553,0.449-1.104,0.765-1.621 c0.309-0.517,0.682-1.017,1.179-1.397c-0.294,1.192-0.608,2.261-1.006,3.363C339.365,157.908,338.91,159.023,338.08,159.954z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83B4B"
    },
    d: "M341.572,160.841c0.027-1.045,0.333-1.967,0.706-2.861c0.401-0.881,0.87-1.732,1.622-2.46 c-0.025,1.046-0.331,1.968-0.706,2.861C342.79,159.261,342.321,160.113,341.572,160.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83B4B"
    },
    d: "M342.015,160.897c0.385,0.147,0.692,0.361,0.977,0.523c0.284,0.167,0.543,0.261,0.637,0.223 c0.182-0.031,0.482-0.139,0.728-0.274c0.259-0.145,0.524-0.324,0.827-0.611c0.117,0.407-0.016,0.859-0.284,1.199 c-0.282,0.348-0.641,0.597-1.169,0.672c-0.644,0.034-1.028-0.348-1.256-0.655C342.234,161.646,342.094,161.297,342.015,160.897 z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.c9c3a32e8cf318c2f0eb26666993f30a.svg";
export { ForwardRef as ReactComponent };